import { createApp } from 'vue'
import App from './App.vue'
import router, { preloadLoginPage } from './router'
import { refreshStaleBuild } from './utils/appFreshness'

refreshStaleBuild()

createApp(App).use(router).mount('#app')

router.isReady().then(() => {
  if (router.currentRoute.value.path !== '/carlist') return

  const preload = () => {
    preloadLoginPage().catch(() => {
      // 预加载失败不影响路由本身，用户点击时仍会按正常流程重试。
    })
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(preload, { timeout: 800 })
  } else {
    window.setTimeout(preload, 300)
  }
})
